import React, { useState, useEffect } from "react";
import { postData } from "../common/utils";
import { decorator } from "../common/decorator";
import { useHistory } from "react-router";
import { NavLink } from "react-router-dom";

import "./likepost.css";

//Draftjs
import { EditorState, convertFromRaw } from "draft-js";
import "draft-js/dist/Draft.css";

//Draftjs - plugins
import Editor from "@draft-js-plugins/editor";

//popupjs - plugins
import Popup from "reactjs-popup";
import "./popupplug.css";

import "./comments.css";
//Images
import profile from "../../assets/images/profile.jpg";
import ellipsis from "../../assets/images/ellipsis.png";
import edit from "../../assets/images/edit.png";
import deletebtn from "../../assets/images/delete.png";

import bdg_teamplayer from "../../assets/images/bdg_teamplayer.png";
import bdg_innovator from "../../assets/images/bdg_innovator.png";
import like_blue2 from "../../assets/images/like_blue2.png";
import like_grey from "../../assets/images/like.png";
import comment from "../../assets/images/comment.png";
import arrowLeft from "../../assets/images/arrow_left.png";
import arrowRight from "../../assets/images/arrow_right.png";
import arrowTop from "../../assets/images/arrow_top.png";
import arrowBottom from "../../assets/images/arrow_bottom.png";
import cancel from "../../assets/images/cancel.png";
import DeleteComment from "./deletecomment_btn";
import LikeComment from "./LikeCommentbtn";

import createEmojiPlugin from '@draft-js-plugins/emoji';
import '@draft-js-plugins/emoji/lib/plugin.css';

//Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import { useAlert } from "react-alert";
import OutsideClickHandler from 'react-outside-click-handler';

//import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";

const PostLike = (props) => {
  const [postLike, setPostLike] = useState(props.data.data.userLike);
  const [postLikesQuantity, setPostLikesQuantity] = useState(props.data.data.LikesQuantity);
  const [allPostLikes, setAllPostLikes] = useState(props.data.data.likes);

  // console.log("Props", props);
  const LikesComp = () => {
    if (postLikesQuantity == 0) {
      return <div></div>;
    } else {
      if (postLikesQuantity < 3) {
        var likeUserName = allPostLikes.map((likeLoop, index) => {
          return likeLoop.userName;
        });
        return (
          <div className="pp-likes-info">
            <p>{likeUserName.join(" and ")} liked the post. </p>
          </div>
        );
      } else {
        var likeUserName = [];
        for (var i = 0; i < allPostLikes.length; i++) {
          if (i < 2) {
            likeUserName.push(allPostLikes[i].userName);
          } else {
            break;
          }
        }
        // props.data.likes.map((like,index) => {
        //   if(index<=1){
        //   return like.userName;
        //   }
        //   else{
        //     break;
        //   }
        // });
        return (
          <div className="pp-likes-info">
            <p>
              {likeUserName.join(", ")} and {postLikesQuantity - 2} others like this{" "}
            </p>
          </div>
        );
      }
    }
  };

  const ControlledPopup = (props) => {
    const [open, setOpen] = useState(false);
    const closeModal = () => setOpen(false);
    return (
      <div>
        <div onClick={() => setOpen((o) => !o)}>
          <LikesComp />
        </div>
        <Popup open={open} closeOnDocumentClick onClose={closeModal}>
          <img
            className="close close-img"
            src={cancel}
            alt=""
            onClick={closeModal}
          />
          <div className="likes">
            <h6 className="pop-title"> All Likes </h6>
          </div>
          <div className="pop-likes">
            {props.data.map((allPostLikes, index) => {
              return (
                <div className="pop-profile">
                  <img
                    className="pop-img"
                    src={
                      process.env.REACT_APP_IMG_URL +
                      (allPostLikes.userImage ? allPostLikes.userImage : "no-img.png")
                    }
                    alt=""
                  />
                  <NavLink
                    activeclassName="pp-profile-name-nav"
                    style={{ textDecoration: "none", color: "black" }}
                    to={"/profile/" + allPostLikes.userID}
                  >
                    <p className="pop-name">{allPostLikes.userName}</p>
                  </NavLink>
                </div>
              );
            })}

          </div>
        </Popup>
      </div>
    );
  };
  function togglePostLike() {
    // console.log("Post toggle like");
    var likeFlag = !postLike;
    postData(process.env.REACT_APP_API_URL + "api/posts/like", {
      postID: props.data.data.postID,
      likeFlag: likeFlag,
    }).then((data) => {
      if (data.issuccessful == true) {
        setPostLike(!postLike);
        if (likeFlag) {
          setPostLikesQuantity(postLikesQuantity + 1);
        } else {
          setPostLikesQuantity(postLikesQuantity - 1);
        }
        //console.log(data.likes);
        setAllPostLikes(data.likes);
      } else {
        //console.log(data.message);
      }
    });
  }

  return (
    <>
      <div className="pp-padd" style={{ marginLeft: "-30px" }}>
        <ControlledPopup data={allPostLikes} />
        <div className="pp-controls">
          <div className="pp-like" onClick={togglePostLike}>
            <img src={postLike ? like_blue2 : like_grey} alt="" style={{ width: "30%" }} />
            <span style={{ fontSize: "17px" }}>Like</span>
          </div>
          <div className="pp-comment" style={{ marginLeft: "-40px" }}>
            <img src={comment} alt="" style={{ width: "17.5%" }} />
            <span style={{ fontSize: "17px" }}>Comment</span>
          </div>
        </div>
      </div>

    </>

  )
}



export default PostLike;